import React, { useCallback, useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import { TableData } from "../../../core/data/interface";
import Table from "../../../core/common/dataTable/index";
// import FeesModal from "./feesModal";
import { collectFessData } from "../../../core/data/json/collectFees";
import StudentModals from "../../peoples/students/studentModals";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
// import TooltipOption from "../../../core/common/tooltipOption";
import useQuery, { _get } from "../../Utils/Helper";
// import { useSelector } from "react-redux";
// import { RootState } from "../../../redux/reducers";
import { SingleValue } from "react-select";
import AcademicYearSelect from "../../../core/common/AcademicYearSelect";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { acadamicTerms } from "../../../core/common/selectoption/selectoption";
import { Button, Input } from "antd";
// import { Target } from "react-feather";
import StudentPayModals from "../../peoples/students/studentPayModals";
import { ButtonGroup } from "react-bootstrap";
import StudentCopyBillModal from "../../peoples/students/StudentCopyBillModals";
import StudentEditBillModals from "../../peoples/students/EditBillModals";
// import StudentEditBillModals from "../../peoples/students/StudentEditBillModals";
// import StudentCopyBillModal from "../../peoples/students/StudentCopyBillModal";
// import StudentCopyBillModal from "../../peoples/students/studentCopyBillModal";

interface Class {
  id: string;
  class_group: string;
  level: string;
  section: string;
}
interface Student {
  admission_no: string;
  student_name: string;
  invoice_count: number;
}
const BillClasses = () => {
  const routes = all_routes;
  const q = useQuery();
  const class_code = q.get("class_code");
  const term = q.get("term");

  const _form = {
    search: "",
    class_code:class_code||"",
    section: "",
    sex: "",
    student_name: "",
    status: "Unpaid",
    school_location: "",
    academic_year: "2024/2025",
    term:term||"",
  };
  const [form, setForm] = useState(_form);
//   const [classes, setClasses] = useState([])

  const [students, setStudents] = useState([]);
  const [admission_no, setAdmissionNo] = useState('')
  const [studentName, setStudentName] = useState('')

  
//   useEffect(() => {
//     // Fetch available classes for selection
//     _get(`classes?query_type=select-all`,
//       (res) => {
//         setClasses(res.data);
//       },
//       (err) => {
//         console.log(err);
//       }
//     );
//   }, []);
  // Extract unique sections from the classes data
//   const unique_sections: string[] = [...new Set(classes?.map((item: Class) => item.section))];
//   const newClass = classes?.filter((x: any) => x.section === form.section)

//   const classOptions = newClass?.map((x: any) => ({ value: x.class_name, label: x.class_name }));


  const getStudentList = useCallback(() => {
    _get(
      `payments?query_type=select-bills&class_code=${form.class_code}&term=${form.term}&&academic_year=${form.academic_year}`,
      (res) => {
        setStudents(res.data);
      },
      (err) => {
        console.log(err);
      }
    );
  }, [form])

  useEffect(() => {
    getStudentList()
  }, [getStudentList])

  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  // Handle "Select All" checkbox
  const handleAddAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedRows(students?.filter((x:Student)=>x.invoice_count<1).map((student: Student) => student.admission_no));
    } else {
      setSelectedRows([]);
    }
  };

  // Handle individual row selection
  const handleAddList = (e: React.ChangeEvent<HTMLInputElement>, admissionNo: string) => {
    if (e.target.checked) {
      setSelectedRows((prev) => [...prev, admissionNo]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== admissionNo));
    }
  };

  // Check if "Select All" checkbox should be checked
  const isAllSelected = students?.length > 0 && (selectedRows?.length === students?.length);

  const columns = [
    {
      title: <Input
        name="admission_no"
        checked={isAllSelected}
        onChange={handleAddAll}
        type="checkbox" />,
      dataIndex: "admission_no",
      render: (text: string, record:any, index:number) => (
        <Input
          name="admission_no"
          checked={(selectedRows?.length>0 &&selectedRows.includes(record.admission_no))}
          onChange={(e) => {
            if(record.invoice_count < 1) {
            handleAddList(e, record.admission_no)}}
          }
          type="checkbox"
        />
      )
    },
    {
      title: "Adm No",
      dataIndex: "admission_no",
      render: (text: string) => (
        <Link to="#" className="link-primary">
          {text}
        </Link>
      )
    },
    {
      title: "Student Name",
      dataIndex: "student_name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link to={routes.studentDetail} className="avatar avatar-md">
            <ImageWithBasePath
              src={record.studentImage}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link> */}
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to={routes.studentDetail}>{text}</Link>
            </p>
            <span className="fs-12">{record.class_name}</span>
          </div>
        </div>
      )
    },
    // {
    //   title: "Class",
    //   dataIndex: "current_class",
    // },
    {
      title: "Amount (₦)",
      dataIndex: "total_invoice",
    },

    // {
    //   title: "Last Date",
    //   dataIndex: "lastDate"
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (text: string) => (
    //     <>
    //       {text === "Paid" ? (
    //         <span className="badge badge-soft-success d-inline-flex align-items-center">
    //           <i className="ti ti-circle-filled fs-5 me-1"></i>
    //           {text}
    //         </span>
    //       ) : (
    //         <span className="badge badge-soft-danger d-inline-flex align-items-center">
    //           <i className="ti ti-circle-filled fs-5 me-1"></i>
    //           {text}
    //         </span>
    //       )}
    //     </>
    //   )
    // },
    {
      title: "Action",
      dataIndex: "invoice_count",
      render: (text: string, record: any, index: number) => (
        <div onClick={() => {
          setAdmissionNo(record.admission_no)
          setForm((p)=>({...p, class_name: record.class_name}))
          setStudentName(record.student_name)

        }
      }>
          {(record.invoice_count > 0 )? (<ButtonGroup>
            <Link  to="#"
            className="btn btn-info"
            data-bs-toggle="modal"
            data-bs-target="#student_bill_update_modal">
              View Details
            </Link>
            <Link
            to="#"
            className="btn btn-warning"
            data-bs-toggle="modal"
            data-bs-target="#copy_fees_collect"
          >
            Copy
          </Link>
          </ButtonGroup> ) : (
            <Link
              to="#"
              className="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#add_fees_collect"
            >
              Bill
            </Link>
          )}
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          {/* {JSON.stringify(form)} */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Fees Collection</h3>
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Fees Collection</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Fees & Billings
                  </li>
                </ol>
              </nav> */}
            </div>

          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Student Billing</h4>
              <div className="d-flex align-items-center flex-wrap">

                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                 {/*  <div className="mb-3">
                    <label className="form-label">Section</label>
                    <CommonSelect
                      className="select"
                      options={unique_sections.map(x => ({ label: x, value: x }))}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          section: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Class</label>
                    <CommonSelect
                      className="select"
                      options={classOptions}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          class_name: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div> */}
                  <div className="mb-3 mt-3">
                    <label className="form-label">Academic Year</label>
                    <AcademicYearSelect
                      onChange={(year) => {
                        setForm((p) => ({ ...p, academic_year: year }))
                      }}
                      selectedYear={form.academic_year}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Term</label>
                    <CommonSelect
                      className="select"
                      options={acadamicTerms}
                      defaultValue={{
                        label: form.term,
                        value: form.term,
                      }}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          term: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div>
                  <div className="mb-3 mt-4">
                    <Button className="btn btn-primary" onClick={() => getStudentList()}>Filter</Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table dataSource={students} columns={columns} Selection={false} />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals 
        admission_no={admission_no} 
        term={form.term}
      />
      <StudentCopyBillModal 
        admission_no={selectedRows.toString()} 
        admission_no1={admission_no}
        term={form.term}
        academic_year={form.academic_year}
        class_name={form.class_code}
      />
      <StudentEditBillModals 
        admission_no={admission_no} 
        term={form.term} 
        academic_year={form.academic_year} 
        student_name={studentName}
        class_name={form.class_code}
      />
    </>
  );
};

export default BillClasses;
